
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 47.32 47.32"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#515358"}},[_c('path',{attrs:{"d":"M0 0h36.4v36.4H0z"}}),_c('path',{attrs:{"d":"M37.85 14.2v4.73h4.74v23.66H18.93v-4.74H14.2v9.47h33.12V14.2h-9.47z"}})])])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/tools_svgs/paste.svg